module.exports = __webpack_public_path__ + "static/media/Slide.b89ee8ba.jpg";